import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MensagemUsuario } from '../../models/chat-bot.model';
import { ActionTable, ColumnsTable } from 'src/app/shared/models/table.model';
import { FilterTable } from 'src/app/shared/models/filter.model';
import { SuporteLocalService } from '../../services/suporte-local.service';
import { ActivatedRoute } from '@angular/router';
import { Ativo } from 'src/app/shared/models/enumerations.model';

@Component({
  selector: 'app-suporte-usuario-list',
  templateUrl: './suporte-usuario-list.component.html',
  styleUrls: ['./suporte-usuario-list.component.scss']
})
export class SuporteUsuarioListComponent extends BaseFormComponent<MensagemUsuario> implements OnInit, OnDestroy {
	
	listColumns: ColumnsTable[] = [
		{id:'pergunta', name: 'Pergunta', title: 'Pergunta', class: '', type: 'string'},
		{id:'visualizado', name: 'Visualizado', title: 'Visualizado', class: '', type: 'boolean'},
		{id:'suporte_respondido', name: 'Respondido', title: 'Respondido', class: '', type: 'boolean'},
  	];
	data: MensagemUsuario[] = [];
	listActions: ActionTable[] = [];
	filterForm: FilterTable[] = [
		{key: 'pergunta', value: '', type: 'string', class: 'col-12 col-md-6', label: 'Pergunta'},
		{key: 'suporte_respondido', value: null, type: 'select', class: 'col-12 col-md-6', label: 'Respondido', options: Ativo}
	];
	filters: any;

	constructor(
		public myServices: SuporteLocalService,
		public activatedRoute: ActivatedRoute,
	) {
		super(activatedRoute);
	}

	ngOnDestroy(): void {
		this.unsubscribeList();
	}

	ngOnInit() {
		this.loading();
		this.get();
	}

	get(): void {
		this.myServices.findAllByUser({'filter_by_user':true}).subscribe({
			next: (res) => {
				this.data = res.map(d => ({ ...d, podeSerAlterada:false}));
				this.loaded();
			},
			error: (error) => {
				this.msgError(error?.error?.message ?? "Ocorreu um erro interno")
			},
		});
	}

}